import { NavigationBar } from '@travelnest/hui';
import { LinkButton } from '@travelnest/merlin.button';
import { Rule } from '@travelnest/merlin.rule';
import { IAvailabilityV3BookingsResponse, IBookingsByPropertyIdParams } from 'api/bookings';
import * as React from 'react';
import { Loader } from '../../../../../view/components/loader/Loader';

import { BookingList } from '../../../../components/booking-list/BookingList';
import { ContentHeader } from '../../../../components/content-header/ContentHeaderContainer';
import { ExpandingMenu } from '../../../../components/expanding-menu/ExpandingMenu';
import { ExpandingMenuItem } from '../../../../components/expanding-menu/ExpandingMenuItem';

interface IPropertyBookingListProps {
	propertyId: string;
	propertyName?: string;
	bookings: IAvailabilityV3BookingsResponse;
	loadingBookings: boolean;
	admin: boolean;
	currentQueryParams: IBookingsByPropertyIdParams;
	onUpdateQueryParams(params: Partial<IBookingsByPropertyIdParams>): void;
}

export const PropertyBookingsList: React.FC<IPropertyBookingListProps> = (props) => {
	const { currentQueryParams, onUpdateQueryParams, bookings, admin, loadingBookings, propertyId, propertyName } = props;
	const eventStatus = currentQueryParams.event_status || [];
	const timePeriod = currentQueryParams.time_period || [];
	const showCancelled = currentQueryParams.event_status?.includes('cancelled') || false;
	const showFailed = currentQueryParams.event_status?.includes('failed') || false;
	const showFuture = currentQueryParams.time_period?.includes('future') || false;
	const showPresent = currentQueryParams.time_period?.includes('present') || false;
	const showPast = currentQueryParams.time_period?.includes('past') || false;
	return (
		<>
			<NavigationBar title={`${propertyName} Bookings`} />
			<div className="portal-wrapper">
				<ContentHeader
					title={`Bookings for ${propertyName}`}
					subtext="List of bookings for your property."
					sticky={true}
					childrenRhs={<>
						<div className="cont-head__rhs-content--align-right">
							<ExpandingMenu>
								<ExpandingMenuItem guttered={true} selected={showFuture}
									onClick={
										() => onUpdateQueryParams(
											{
												time_period: showFuture
													? currentQueryParams.time_period?.filter((e) => e !== 'future')
													: [...timePeriod, 'future'],
											}
										)
									}>Show future</ExpandingMenuItem>
								<ExpandingMenuItem guttered={true} selected={showPresent}
									onClick={
										() => onUpdateQueryParams(
											{
												time_period: showPresent
													? currentQueryParams.time_period?.filter((e) => e !== 'present')
													: [...timePeriod, 'present'],
											}
										)
									}>Show current</ExpandingMenuItem>
								<ExpandingMenuItem guttered={true} selected={showPast}
									onClick={
										() => onUpdateQueryParams(
											{
												time_period: showPast
													? currentQueryParams.time_period?.filter((e) => e !== 'past')
													: [...timePeriod, 'past'],
											}
										)
									}>Show completed</ExpandingMenuItem>
								<ExpandingMenuItem guttered={true} ><Rule /></ExpandingMenuItem>
								<ExpandingMenuItem guttered={true} selected={showCancelled}
									onClick={
										() => onUpdateQueryParams(
											{
												event_status: showCancelled
													? currentQueryParams.event_status?.filter((e) => e !== 'cancelled')
													: [...eventStatus, 'cancelled'],
											}
										)
									}>Show cancelled</ExpandingMenuItem>
								{admin && <ExpandingMenuItem guttered={true} selected={showFailed}
									onClick={
										() => onUpdateQueryParams(
											{
												event_status: showFailed
													? currentQueryParams.event_status?.filter((e) => e !== 'failed')
													: [...eventStatus, 'failed'],
											}
										)
									}>Show failed</ExpandingMenuItem>}
								<ExpandingMenuItem guttered={true} ><Rule /></ExpandingMenuItem>
								<ExpandingMenuItem guttered={true} selected={currentQueryParams.sort_direction === 'ascending'}
									onClick={() => onUpdateQueryParams({ sort_direction: 'ascending' })}>Sort Arriving First</ExpandingMenuItem>
								<ExpandingMenuItem guttered={true} selected={currentQueryParams.sort_direction === 'descending'}
									onClick={() => onUpdateQueryParams({ sort_direction: 'descending' })}>Sort Arriving Last</ExpandingMenuItem>
							</ExpandingMenu>
						</div>
						{admin &&
							<div className="admin-bookings-view-button">
								<LinkButton to={`/admin/bookings/property/${propertyId}/create`}>Add new booking</LinkButton>
							</div>
						}
					</>}
				/>
				{
					loadingBookings ? <Loader message={'Your bookings are loading.'} loading /> :
						<BookingList
							bookings={bookings}
							loading={loadingBookings}
							paginate={(pageNumber: number) => onUpdateQueryParams({ page_number: pageNumber })}
						/>
				}
			</div>
		</>
	);
};
